import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy redirect — contract-type management was consolidated into the
// master-detail hierarchy editor at `/$org/contract-types` (spec
// 2026-08-01-22), mirroring the folder-layout editor. Kept so old
// bookmarks/deep links keep working.
export const Route = createFileRoute('/$org/contract-types/$contractTypeUid')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/$org/contract-types',
            params: { org: params.org },
            search: { contract_type_uid: params.contractTypeUid },
        })
    },
})
